import { render, staticRenderFns } from "./BaseSnackbarUI.vue?vue&type=template&id=70f0606a"
import script from "./BaseSnackbarUI.vue?vue&type=script&lang=js"
export * from "./BaseSnackbarUI.vue?vue&type=script&lang=js"
import style0 from "./BaseSnackbarUI.vue?vue&type=style&index=0&id=70f0606a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports